import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-decline',
  templateUrl: './decline.component.html',
  styleUrls: ['./decline.component.scss']
})
export class DeclineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
